<template>
  <div class="d-flex w-100 flex-column gap-xs">
    <div v-if="!preview">
      <ion-img
        :src="imageOptions[type as keyof typeof imageOptions]"
        alt="Welcome Hero"
        class="principal-welcome-image mb-lg"
      ></ion-img>
    </div>

    <div v-if="rentalUnit && preview" class="mb-lg">
      <RentalUnitPreviewCard
        :name="getCurrentName(rentalUnit as RentalUnit, languageSelected) as string"
        :image="
          getCoverImage(
            rentalUnit.Images.length > 0
              ? rentalUnit.Images
              : (rentalUnit.Property?.Images as Photos[]),
          )
        "
        :rental-unit="rentalUnit"
      />
    </div>

    <h1 v-if="user" class="font-lg bold-medium">
      {{ t(`${type}.welcome`) }}{{ ` ${user.name ?? user.fullName ?? user.email}!` }}
    </h1>
    <h1 v-else class="font-lg bold-medium">{{ t(`${type}.welcome`) }}!</h1>
    <p class="font-sm text-align-left mt-sm">
      {{ !preview ? t(`${type}.description`) : t(`evaluator.firstStep`) }}
    </p>
    <p class="font-sm text-align-left">{{ t(`${type}.stepOne`) }}</p>
    <p class="font-sm text-align-left">{{ t(`${type}.stepTwo`) }}</p>

    <ion-button
      @click="$emit('next-step')"
      fill="solid"
      expand="block"
      size="large"
      color="accent"
      class="text-lg text-weight-bold mt-lg"
    >
      {{ t(`${type}.startCheck`) }}
    </ion-button>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { IonImg, IonButton } from '@ionic/vue';
  import welcomeDoor from '@/assets/images/welcomeDoor.png';
  import welcomeCheckout from '@/assets/images/welcomeCheckout.png';
  import { User } from '@/interfaces/auth/auth-store.interface';
  import { useSearch } from '@/composables/useSearch';
  import { Photos, RentalUnit } from '@/interfaces/elastic/elastic.interface';
  import RentalUnitPreviewCard from '../RentalUnitPreviewCard.vue';
  import { useProfileStore } from '@/stores/profile-store';
  import { storeToRefs } from 'pinia';

  const { getCurrentName, getCoverImage } = useSearch();
  const { languageSelected } = storeToRefs(useProfileStore());

  withDefaults(
    defineProps<{
      type: string;
      user: User;
      preview?: boolean;
      rentalUnit?: RentalUnit;
    }>(),
    {},
  );

  const { t } = useI18n();
  const imageOptions = {
    'check-in': welcomeDoor,
    'check-out': welcomeCheckout,
  };
</script>

<style lang="css">
  .principal-welcome-image {
    width: 100%;
    max-height: 328px;
    height: 100%;
    object-fit: contain;
  }
</style>
